import { useEffect, useState } from "react"

const MOBILE_BREAKPOINT = 768

/** Spiegelt Tailwinds `md`-Breakpoint (768px), analog zu `apps/frontend/src/hooks/useIsMobile.ts`. */
export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    () => window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`).matches
  )

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    function onChange(event: MediaQueryListEvent) {
      setIsMobile(event.matches)
    }
    mql.addEventListener("change", onChange)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return isMobile
}
